






import { Vue, Component, Prop } from 'vue-property-decorator';

const GRID = 100 / 12;

@Component({})
export default class Cell extends Vue {
  @Prop({}) readonly size?: number;
  @Prop({}) readonly max?: number;
  @Prop({}) readonly min?: number;
  @Prop({}) readonly margin?: number;

  get style() {
    return [
      `width: ${this.size ? GRID * this.size + '%' : 'auto'}`,
      this.max ? `max-width: ${this.max}px` : '',
      this.min ? `min-width: ${this.min}px` : '',
      this.margin ? `margin-right: ${this.margin}px` : ''
    ].join(';');
  }
}
